var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 5,
    viewBox: "0 0 6 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72058 4.25115C3.32718 4.65999 2.67282 4.65999 2.27942 4.25115L0.299325 2.19338C-0.311997 1.55807 0.138241 0.499999 1.0199 0.499999L4.9801 0.5C5.86176 0.5 6.312 1.55807 5.70068 2.19338L3.72058 4.25115Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigPolygon);
export default __webpack_public_path__ + "static/media/jobconfig-polygon.bf450b3c4b1135dacd2b0ad9288ffa2f.svg";
export { ForwardRef as ReactComponent };